import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import Loading from 'uI/Loading/Loading';
import BreadCrumb from 'uI/BreadCrumb/BreadCrumb';
import LeftSection from './LeftSection/LeftSection';
import RightSection from './RightSection/RightSection';

import { accesBook, bookProduct } from 'store/product-actions';

import classes from './ProductBook.module.css';

const ProductBook = () => {
  const { productType, academyName, idProduct } = useParams();
  const [loading, setLoading] = useState(true);
  const [bookData, setBookData] = useState([]);
  const [access, setAccess] = useState(false);
  const [loadAccess, setLoadAccess] = useState(false);

  useEffect(() => {
    (async () => {
      setBookData(
        await bookProduct(idProduct, academyName, 'EDUSTORE', 'BOOK')
      );
    })();
  }, []);

  useEffect(() => {
    if (!loadAccess && bookData.idAcademy) {
      (async () => {
        setAccess(await accesBook(idProduct));
        setLoadAccess(true);
        setLoading(false);
      })();
    }
  }, [bookData]);

  return (
    <>
      {!loading ? (
        <>
          <BreadCrumb
            productType={productType}
            productName={bookData.academyName}
          />
          <div className={classes.productContainer}>
            <LeftSection data={bookData.data[0]} />
            <RightSection data={bookData.data[0]} access={access} />
          </div>
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default ProductBook;
